import { AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as L from 'leaflet';
import { MyGeoJson } from 'src/app/data/model/geoJson';
import { ServiceOrder } from 'src/app/data/model/service-order';
import { Waypoint } from 'src/app/data/model/waypoints';
import { mapURL } from 'src/environments/environment.api';
import { OdsWaypointsListService } from '../../services/ods-waypoints-list.service';

@Component({
  standalone: false,
  selector: 'app-ods-waypoints-map-dialog',
  templateUrl: './ods-waypoints-map-dialog.component.html',
  styleUrls: ['./ods-waypoints-map-dialog.component.scss']
})
export class OdsWaypointsMapDialogComponent implements AfterViewInit, OnInit {

  constructor(
    private geoService: OdsWaypointsListService,
    @Inject(MAT_DIALOG_DATA) public data: ServiceOrder
  ) { }

  @Output() map$: EventEmitter<L.Map>= new EventEmitter;
  @Output() zoom$: EventEmitter<number>=new EventEmitter;
  zoom!:number;
  public map!: L.Map;
  layer = new L.FeatureGroup();
  geoRes:any;

 
  mapUrl = mapURL.mapUrl !== '${mapURL}' ? mapURL.mapUrl : mapURL.defaultMapUrl;
  @Input() options: L.MapOptions= {
      layers:[L.tileLayer(`${this.mapUrl}/styles/m2openmaptiles/{z}/{x}/{y}.png`, {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    })],
    zoom:7,
    center:L.latLng(43.300084381319905, 12.34134765625),
  };

  ngOnInit(): void {
    
  }
  ngAfterViewInit(): void {
    if(this.data){
      this.layer.clearLayers();
      this.geoService.loadWayPoints(this.data.id);
    }
  }
  
  setRoute(map_group: L.FeatureGroup) {
    if(this.data){

      L.geoJSON(this.data?.route_item?.route ? this.data?.route_item?.route : this.data?.pickup_route_item?.route as any).addTo(map_group);
      
    }

  }

  setColor(percent:number){
    if(percent===0 || percent<=10){
      return "red";
    }
    else if(percent>10 && percent<=50){
      return "orange";
    }
    else if(percent>50 && percent<=90){
      return "yellow";
    }
    else if (percent>90){
      return "green";
    }
    else{
      return "black";
    }
  }

 setIcon(type:String){
  if (type === 'start') {
    return L.Icon.extend({
      options:
        {
          iconSize: [21, 31], // size of the icon
          iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -51],  
          iconUrl: '../../../../assets/images/start.svg'
        }
      })
  } else if (type === 'stop') {
    return L.Icon.extend({
      options:
        {
          iconSize: [21, 31], // size of the icon
          iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -51],  
          iconUrl: '../../../../assets/images/arrivo.svg'
        }
      })
  } else {
    return L.Icon.extend({
      options:
      {
        iconSize: [21, 31], // size of the icon
        iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
        popupAnchor: [0, -51],  
        iconUrl: '../../../../assets/images/mark.png',
        shadowUrl: '../../../../assets/images/markshadow.png'
      }
      })
  }
}

setIconByStatus(type:number){
  if (type === 0) {
    return L.Icon.extend({
      options:
        {
          iconSize: [21, 31], // size of the icon
          iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -51],  
          iconUrl: '../../../../assets/images/pending.svg',
          shadowUrl: '../../../../assets/images/markshadow.png'
        }
      })
  } else if (type === 1) {
    return L.Icon.extend({
      options:
        {
          iconSize: [21, 31], // size of the icon
          iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -51],  
          iconUrl: '../../../../assets/images/completed.svg',
          shadowUrl: '../../../../assets/images/markshadow.png'
        }
      })
  } else if (type === 2) {
    return L.Icon.extend({
      options:
        {
          iconSize: [21, 31], // size of the icon
          iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -51],  
          iconUrl: '../../../../assets/images/unreachable.svg',
          shadowUrl: '../../../../assets/images/markshadow.png'
        }
      })
  }else if (type === 3) {
    return L.Icon.extend({
      options:
        {
          iconSize: [21, 31], // size of the icon
          iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -51],  
          iconUrl: '../../../../assets/images/not_found.svg',
          shadowUrl: '../../../../assets/images/markshadow.png'
        }
      })
  } else if (type === 4) {
    return L.Icon.extend({
      options:
        {
          iconSize: [21, 31], // size of the icon
          iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -51],  
          iconUrl: '../../../../assets/images/marker-icon-red.png',
          shadowUrl: '../../../../assets/images/markshadow.png'
        }
      })
  }  else {
    return L.Icon.extend({
      options:
      {
        iconSize: [21, 31], // size of the icon
        iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
        popupAnchor: [0, -51],  
        iconUrl: '../../../../assets/images/mark.png',
        shadowUrl: '../../../../assets/images/markshadow.png'
      }
      })
  }
}

 setPoint(results: Waypoint[]) {
  const markerClusterGroup = L.markerClusterGroup();
  for (const c of results) {
    //const [date, time] = c.gps_timestamp.split("T");
    const timestamp = new Date(c.device_timestamp).toLocaleString();
    //if(date >= start_date && date<= end_date){
    const coords = c.coords.split(" ");
    const mark1= coords[1].split("(");
    const mark2= coords[2].split(")");
    const point = new L.LatLng(Number(mark1[1]), Number(mark2[0])); //mark2[0], mark1[1]);//(mark1[1], mark2[0]);
    //const marker = new A.RotatedMarker(point, {icon:new this.myicon, rotationAngle:c.angle}).bindPopup(data, {closeButton: false});
    if(c.order == 0){
      const start_icon=this.setIcon('start');
       L.marker(point, {icon:new start_icon}).addTo(markerClusterGroup).bindPopup(c.address, {closeButton: false});
    }
    else if(c.order == results.length-1){
      const finish_icon=this.setIcon('stop');
      L.marker(point, {icon:new finish_icon}).addTo(markerClusterGroup).bindPopup(c.address, {closeButton: false});
    }
    else {
      const myicon=this.setIconByStatus(c.status);
      L.marker(point, {icon:new myicon}).addTo(markerClusterGroup).bindPopup(`<b>Indirizzo:</b> ${c.address} <b>Stato:</b> ${c.status_string}`, {closeButton: false});
    }
  }
  //markerClusterGroup.addTo(this.layer);
  return markerClusterGroup;
   
 }


  unsub(){
    //this.data.destroy();
    this.geoRes.unsubscribe();
  }

  onMapReady(map: L.Map) {

      this.map = map;
      this.map$.emit(map);
      this.zoom = map.getZoom();
      this.zoom$.emit(this.zoom);
      const img=[
        '../../../../assets/images/pending.svg',
        '../../../../assets/images/completed.svg',
        '../../../../assets/images/unreachable.svg',
        '../../../../assets/images/not_found.svg',
        '../../../../assets/images/marker-icon-red.png',
      ];
      const status=[
        'In attesa',
        'Raccolto',
        'Irraggiungibile',
        'Assente',
        'Errore'
      ];
      const color=[
        'blue',
        'green',
        'orange',
        'black',
        'red'
      ];
      const legend = new (L.Control.extend({
        options: {position: 'bottomleft'},
        onAdd(map:L.Map): HTMLElement{
          const div = L.DomUtil.create('div', 'legend');
          div.style.backgroundColor='#ffffff';
          div.style.opacity='70%';
          for(let i=0; i<status.length; i++){
            if(img[i] === '../../../../assets/images/marker-icon-red.png'){
              div.innerHTML+='<h3 style=color:'+color[i]+'; opacity:100%; text-shadow: 50px  40px 40px '+color[i]+';>'+(" <img src="+ img[i] +" height='30' width='20'>")+status[i]+'</h3>'
            } else {
              div.innerHTML+='<h3 style=color:'+color[i]+'; opacity:100%; text-shadow: 50px  40px 40px '+color[i]+';>'+(" <img src="+ img[i] +" height='30' width='30'>")+status[i]+'</h3>'
            }
            i+1;
          }
          div.style.borderRadius='10px'
          div.style.padding='10px'
          return div
        }
      }));
      legend.addTo(map);
      //this.setRoute(this.layer);
      this.geoRes=this.geoService.waypoint$.subscribe((geometryResponse: Waypoint[] | null) => {
        if(geometryResponse) {
          this.setRoute(this.layer);
          const markerClusterGroup = this.setPoint(geometryResponse);
          markerClusterGroup.addTo(this.layer);
          this.layer.addTo(this.map);
          map.fitBounds(this.layer.getBounds());
        }
      })
      setTimeout(() => {
        this.map.invalidateSize();
      }, 0);
    }

  onMapZoomEnd(e: L.LeafletEvent) {
    this.zoom = e.target.getZoom();
    this.zoom$.emit(this.zoom);
  }
}

export type DialogMapParams = {
  data: any;
};
